import { DrawerHeader, DrawerHeaderTitle, DrawerBody, DrawerFooter, Button, Input, Checkbox, Body1Strong, Label, tokens, OverlayDrawer } from "@fluentui/react-components";
import { AppsFilled, Dismiss24Regular } from "@fluentui/react-icons";
import { useCallback, useState } from "react";
import LinkWithIcon from "../LinkWithIcon";

export enum EnabledProductFeatureFlags {
    Flighting = 1 << 0,
    Experiments = 1 << 1,
    Telemetry = 1 << 2
};

export default function NewProductDrawer(
    {
        open,
        setOpen,
        createProductCallback
    }: {
        open: boolean,
        setOpen: React.Dispatch<React.SetStateAction<boolean>>,
        createProductCallback: (
            name: string,
            enabledFeatures: EnabledProductFeatureFlags
        ) => void
    }
) {
    const [ enableFlighting, setEnableFlighting ] = useState( true );
    const [ enableExperiments, setEnableExperiments ] = useState( true );
    const [ enableTelemetry, setEnableTelemetry ] = useState( true );
    const [ productName, setProductName ] = useState("");
    const [ enabledFeatures, setEnabledFeatures ] = useState<EnabledProductFeatureFlags>(0 as EnabledProductFeatureFlags);

    const createProduct = useCallback(
        () => {
            createProductCallback( productName, enabledFeatures );
            setOpen(false);
        },
        []
    );

    return (
        <>
            <OverlayDrawer modalType="modal" open={open} onOpenChange={( _, d ) => setOpen(d.open)} size="medium" position="end">
                <DrawerHeader>
                    <DrawerHeaderTitle
                        action={
                            <Button
                                appearance="subtle"
                                aria-label="close"
                                icon={<Dismiss24Regular />}
                                onClick={() => setOpen(false)}
                            />
                        }>
                        <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
                            <AppsFilled /> New Product
                        </div>
                    </DrawerHeaderTitle>
                </DrawerHeader>
                <DrawerBody>
                    <Label htmlFor="new-product-dialog-input" style={{ fontWeight: tokens.fontWeightSemibold }}>Name</Label>
                    <Input placeholder="Name" type="text" style={{ width: "100%" }} id="new-product-dialog-input" defaultValue="Example Product" />
                    
                    <div style={{ marginTop: "1rem" }}>
                        <Body1Strong>Product Features</Body1Strong>
                        <dl>
                            <dd>
                                <Checkbox label={<div>Enable experiments (<LinkWithIcon href="/help/experiments" text="What are experiments?" newTab={true} />)</div>} checked={enableExperiments} onChange={( _, d ) => setEnableExperiments(d.checked as boolean)} />
                            </dd>
                            <dd>
                                <Checkbox label={<div>Enable telemetry (<LinkWithIcon href="/help/telemetry" text="What is telemetry?" newTab={true} />)</div>} checked={enableTelemetry} onChange={( _, d ) => setEnableTelemetry(d.checked as boolean)} />
                            </dd>
                        </dl>
                    </div>
                </DrawerBody>
                <DrawerFooter>
                    <Button appearance="primary" onClick={createProduct}>
                        Create
                    </Button>
                </DrawerFooter>
            </OverlayDrawer>
        </>
    );
}